import "./ionic-modal-select.js";



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/